import React from 'react';
import Cart from './Cart';

// CartModal can probably be replaced/deleted now that 'publicWebNavCartModal' is live.

const CartModal = () => (
  <div id="cart-modal">
    <div className="modal-body">
      <Cart />
    </div>
  </div>
);

export default CartModal;



// WEBPACK FOOTER //
// ./src/components/cart/CartModal.jsx